var placeholderImg = "/static/9bcb34135660c98b.png";

export { placeholderImg as default };
//# sourceMappingURL=placeholder.png.js.map
